module.exports = __webpack_public_path__ + "img/section2_m.67ccb0a2.jpg";